var map = {
	"./admin.svg": 38141,
	"./all.svg": 32265,
	"./avatar.svg": 22395,
	"./back.svg": 11249,
	"./check.svg": 63888,
	"./clear.svg": 98895,
	"./close.svg": 89500,
	"./collapse.svg": 94701,
	"./confirm.svg": 83592,
	"./create-order.svg": 20015,
	"./delete.svg": 30129,
	"./edit.svg": 71452,
	"./ellipsis.svg": 80105,
	"./email.svg": 32848,
	"./forward.svg": 89359,
	"./important.svg": 65410,
	"./inbound.svg": 50015,
	"./info.svg": 29780,
	"./jobs.svg": 63656,
	"./jump.svg": 99252,
	"./labels.svg": 11117,
	"./lock.svg": 54381,
	"./logo.svg": 92957,
	"./minus.svg": 91056,
	"./mobile-task.svg": 49908,
	"./mobile-user.svg": 46694,
	"./new-group.svg": 95560,
	"./note.svg": 37988,
	"./notification.svg": 79109,
	"./order.svg": 31360,
	"./outbound.svg": 27964,
	"./pencil.svg": 82759,
	"./plus.svg": 39128,
	"./plus2.svg": 18202,
	"./port.svg": 36657,
	"./print.svg": 82157,
	"./read.svg": 14076,
	"./reset.svg": 73093,
	"./rii.svg": 86820,
	"./run.svg": 53367,
	"./scissor.svg": 40198,
	"./settings.svg": 93071,
	"./shipment.svg": 25710,
	"./start.svg": 22932,
	"./stock.svg": 96274,
	"./success.svg": 90201,
	"./tools.svg": 59569,
	"./trash.svg": 18798,
	"./trashed.svg": 22657,
	"./unimportant.svg": 78849,
	"./unread.svg": 46317,
	"./warning.svg": 9876,
	"./xmark.svg": 25163
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 30279;